
import { Vue } from "vue-class-component";

export default class FontSelect extends Vue {
  fontClasses = ["impact", "tf2", "times", "courier", "comic", "system"];

  change(fontClass: string) {
    this.$store.commit("setFont", fontClass);
  }
}
